import React, { useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || '';
const LOGO = '/dailyreps3.png';

export default function Support() {
  const [userType, setUserType] = useState('');
  const [form, setForm] = useState({ name: '', club_name: '', team_name: '', username: '', email: '', message: '' });
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);
    try {
      const res = await fetch(`${API_BASE}/api/support`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_type: userType, ...form }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to submit');
      setSuccess(true);
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };

  if (success) {
    return (
      <div style={{ minHeight: '100vh', background: '#f5f7fa', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <img src={LOGO} alt="Train Daily" style={{ width: 64, marginBottom: 16 }} />
        <div style={{ background: '#fff', borderRadius: 12, padding: '32px 28px', maxWidth: 480, width: '100%', textAlign: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
          <h2 style={{ marginBottom: 12, color: '#1a1a2e' }}>Thank You!</h2>
          <p style={{ color: '#555', marginBottom: 20 }}>Your support request has been submitted. We'll get back to you as soon as possible.</p>
          <a href="/" className="btn btn-orange" style={{ display: 'inline-block', textDecoration: 'none' }}>Back to Home</a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 20px' }}>
      <img src={LOGO} alt="Train Daily" style={{ width: 64, marginBottom: 16 }} />
      <h1 style={{ fontSize: '1.5rem', color: '#1a1a2e', marginBottom: 4 }}>Train Daily Support</h1>
      <p style={{ color: '#555', marginBottom: 24, fontSize: '0.95rem' }}>How can we help?</p>
      <div style={{ background: '#fff', borderRadius: 12, padding: '28px 24px', maxWidth: 480, width: '100%', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">I am a...</label>
            <select className="form-input" value={userType} onChange={(e) => setUserType(e.target.value)} required>
              <option value="">Select one</option>
              <option value="Club Admin">Club Admin</option>
              <option value="Coach">Coach</option>
              <option value="Parent">Parent</option>
              <option value="Player">Player</option>
            </select>
          </div>

          {userType && (
            <>
              <div className="form-group">
                <label className="form-label">Your Name</label>
                <input className="form-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
              </div>

              {userType === 'Club Admin' && (
                <div className="form-group">
                  <label className="form-label">Club Name</label>
                  <input className="form-input" value={form.club_name} onChange={(e) => setForm({ ...form, club_name: e.target.value })} required />
                </div>
              )}

              {userType === 'Coach' && (
                <>
                  <div className="form-group">
                    <label className="form-label">Club Name <span style={{ fontWeight: 400, color: '#888' }}>(leave blank if not part of a club)</span></label>
                    <input className="form-input" value={form.club_name} onChange={(e) => setForm({ ...form, club_name: e.target.value })} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Team Name</label>
                    <input className="form-input" value={form.team_name} onChange={(e) => setForm({ ...form, team_name: e.target.value })} required />
                  </div>
                </>
              )}

              {(userType === 'Parent' || userType === 'Player') && (
                <div className="form-group">
                  <label className="form-label">Username</label>
                  <input className="form-input" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} autoCapitalize="none" />
                </div>
              )}

              <div className="form-group">
                <label className="form-label">Email</label>
                <input className="form-input" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required autoCapitalize="none" />
              </div>

              <div className="form-group">
                <label className="form-label">Your Message</label>
                <textarea className="form-input" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required />
              </div>

              {error && <div style={{ background: '#f8d7da', color: '#721c24', padding: '8px 12px', borderRadius: 6, marginBottom: 12, fontSize: '0.9em' }}>{error}</div>}

              <button type="submit" className="btn btn-orange" style={{ width: '100%' }} disabled={saving}>
                {saving ? 'Submitting...' : 'Submit'}
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
